"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DatePickerInput = _interopRequireDefault(require("./DatePickerInput"));

var _moment = _interopRequireDefault(require("moment"));

require("moment-timezone");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Spacer = _styledComponents["default"].div.attrs(function () {
  return {
    className: "mx-2"
  };
}).withConfig({
  displayName: "DateRangePickerInput__Spacer",
  componentId: "sc-1h6rtjg-0"
})(["font-weight:bold;font-size:1.3rem;"]);

var DateRangePickerInput = function DateRangePickerInput(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      minDate = _ref.minDate,
      onChange = _ref.onChange,
      maxDate = _ref.maxDate,
      timeZone = _ref.timeZone,
      styles = _ref.styles,
      rest = _objectWithoutProperties(_ref, ["value", "minDate", "onChange", "maxDate", "timeZone", "styles"]);

  var updateStart = function updateStart(newValue) {
    onChange({
      start: newValue,
      end: value.end
    });
  };

  var updateEnd = function updateEnd(newValue) {
    onChange({
      start: value.start,
      end: newValue
    });
  };

  var isValidDateRange = function isValidDateRange(value) {
    var start = _moment["default"].isMoment(value.start) ? value.start : (0, _moment["default"])(value.start);
    var end = _moment["default"].isMoment(value.end) ? value.end : (0, _moment["default"])(value.end);
    return end.isAfter(start) || end.diff(start) === 0;
  };

  var className = !isValidDateRange(value) ? "is-invalid" : "";
  return _react["default"].createElement("div", {
    className: "d-flex align-items-center",
    id: "date-range-picker"
  }, _react["default"].createElement(_DatePickerInput["default"], _extends({
    value: value.start,
    onChange: updateStart,
    minDate: minDate,
    maxDate: maxDate,
    timeZone: timeZone,
    className: className,
    name: "date-range-start",
    styles: styles
  }, rest)), _react["default"].createElement(Spacer, null, " - "), _react["default"].createElement(_DatePickerInput["default"], _extends({
    value: value.end,
    onChange: updateEnd,
    minDate: minDate,
    maxDate: maxDate,
    timeZone: timeZone,
    name: "date-range-end",
    className: className,
    styles: styles
  }, rest)));
};

DateRangePickerInput.propTypes = {
  /** value of the date range picker */
  value: _propTypes["default"].shape({
    start: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].instanceOf(Date)]),
    end: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].instanceOf(Date)])
  }).isRequired,
  onChange: _propTypes["default"].func.isRequired,

  /** min date allowed to selected */
  minDate: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].instanceOf(Date)]),

  /** max date allowed to selected */
  maxDate: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].instanceOf(Date)]),

  /** time zones of the dates  */
  timeZone: _propTypes["default"].string,

  /** styles object to override date picker */
  styles: _propTypes["default"].object
};
DateRangePickerInput.defaultProps = {
  minDate: (0, _moment["default"])(new Date("1/1/2011").valueOf()),
  maxDate: (0, _moment["default"])(new Date("1/1/2050").valueOf()),
  timeZone: _moment["default"].tz !== undefined ? _moment["default"].tz.guess() : "America/New_York",
  styles: {}
};
var _default = DateRangePickerInput;
exports["default"] = _default;